import axios from "axios";

const httpRequest =  axios.create({
    baseURL: import.meta.env.VITE_PAI_API_URL,
})

export default httpRequest;
